import {gsap} from "gsap";
<template>
  <div class="solutions desktop" ref="solutions">
    <div class="outer" ref="outer">
      <h2>Energielösungen von morgen</h2>
      <div class="wrapper">
        <div class="nav">
          <ul>
            <li v-for="(slide, index) in slides" :key="'nav_' + index" :class="{'current': index === current}">
              <button :data-from-active="Math.abs(index - current)" @click="goTo(index)">{{slide.title}}</button>
            </li>
          </ul>
        </div>
        <div class="slides">
          <div class="slide"
               v-for="(slide, index) in slides"
               :key="'slide_' + index"
               :class="{'current': index === current, 'prev': index < current, 'next': index > current}"
               :style="calcTransform(index)"
               ref="slideItems">
            <div class="text-box">
              <h3 v-html="slide.headline"/>
              <p v-for="p in slide.copy" :key="p" v-html="p"/>
            </div>
            <div class="image-box" :style="calcImage1Transform(index)">
              <img :src="getImageUrl(slide.images[0])" alt="">
            </div>
            <div class="image-box" :style="calcTransform(index)">
              <img :src="getImageUrl(slide.images[1])" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mobile-solutions">
    <h2>Energielösungen von morgen</h2>
    <div class="tabs">
      <ul>
        <li v-for="(slide, index) in slides" :key="'nav_' + index" :class="{'active': index === mobileCurrent}">
          <button :data-from-active="Math.abs(index - current)" :data-index="index" @click="scrollerClick">{{slide.title}}</button>
        </li>
      </ul>
    </div>
    <div class="items" ref="mobileWrapper">
      <div class="item" v-for="(slide, index) in slides"
           :key="'slide_' + index"
           :class="{'current': index === current, 'prev': index < current, 'next': index > current}"
           ref="mobileItems">
        <div class="text" :style="{'opacity': mobileTexts[index]}">
          <h3 v-html="slide.headline"/>
          <p v-for="p in slide.copy" :key="p" v-html="p"/>
        </div>
        <div class="images">
          <img :src="getImageUrl(slide.images[1])" alt="">
          <img :src="getImageUrl(slide.images[0])" alt="" :data-index="index" @load="initScroller">
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import {Cubic, gsap} from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    name: "ProfileSolutions",
    data() {
      return {
        current: -1,
        currentProgress: 0,
        currentOffset: 0,
        controller: null,
        mobileTexts: [],
        mobileCurrent: 0,
        isScrolling: false,
        slides: [
          {
            title: 'Strom',
            headline: 'Der Umwelt zuliebe: <br>Bei uns gibt es 100 % Ökostrom in jedem Tarif',
            copy: [
              'Auf dem Weg in eine grüne Zukunft: Seit dem 1. Januar 2018 versorgen wir alle Privatkunden bundesweit mit 100 Prozent Ökostrom aus Sonne, Wind, Biomasse und Wasser.',
              'Damit gehört enercity zu den fünf größten Ökostromanbietern in Deutschland.'
            ],
            images: ['strom-01.jpg', 'strom-02.jpg']
          },
          {
            title: 'Solar',
            headline: 'Die Kraft der Sonne nutzen: <br>Leistungsstarke Solaranlagen zum Kauf oder zur Miete',
            copy: [
              'Mit enercity Solar bieten wir unseren Kundinnen und Kunden deutschlandweit leistungsstarke Solaranlagen zum Kauf oder zur Miete an. Neben hochwertigen Komponenten und der fachgerechten Installation erhalten sie vielfältige Serviceleistungen rund um den Betrieb der Anlagen – wie Fernüberwachung, regelmäßige Wartung und einen umfassenden Versicherungsschutz.'
            ],
            images: ['solar-01.jpg', 'solar-02.jpg']
          },
          {
            title: 'Wärme',
            headline: 'Wärmepumpen, grüne Fernwärme, Holzenergie und CO<sub>2</sub>: Klimaschonend heizen mit enercity',
            copy: [
              'Bei enercity finden Kundinnen und Kunden exakt auf ihre individuellen Bedürfnisse angepasste, umweltschonende Wärmeangebote: von klimaneutralem Erdgas über saubere Fernwärme und hocheffiziente Wärmepumpen bis hin zum CO<sub>2</sub>-neutralen Heizen mit Holzenergie.'
            ],
            images: ['waerme-01.jpg', 'waerme-02.jpg']
          },
          {
            title: 'Wasser',
            headline: 'Natürlich aus der Region: <br>Sauberes Trinkwasser für 700.000 Menschen',
            copy: [
              'Drei Wasserwerke, in Elze-Berkhof, Fuhrberg und Grasdorf, versorgen die Menschen in Hannover und Region mit hochwertigem Trinkwasser. Insgesamt speist enercity jedes Jahr rund 43 Millionen Kubikmeter Wasser in das Netz ein. Das entspricht in etwa dem Inhalt des Steinhuder Meeres.',
              'enercity Wasser unterschreitet die strengen Grenzwerte der Trinkwasserverordnung in allen Punkten. Das kommt nicht von ungefähr: Wir haben jahrzehntelange Erfahrung in der Gewinnung und Aufbereitung von Trinkwasser.'
            ],
            images: ['wasser-01.jpg', 'wasser-02.jpg']
          },
          {
            title: 'E-Mobilität',
            headline: 'Hannover fährt vor: Wir denken Mobilität neu!',
            copy: [
              'Private Wallboxen für das Eigenheim, Ladelösungen für Mehrfamilienhäuser, Fuhrparkmanagement oder Ladesäulen für Kundinnen und Kunden sowie Mitarbeitende: unsere cleveren und praktikablen Lösungen machen den Einstieg in die E-Mobilität einfach. Auch zu staatlichen Fördermöglichkeiten beraten wir gern.'
            ],
            images: ['mobil-01.jpg', 'mobil-02.jpg']
          },
          {
            title: 'Smart Home',
            headline: 'Maßgeschneidert und zukunftssicher: <br>Intelligente Lösungen für die Wohnungswirtschaft',
            copy: [
              'Vom smarten Türschloss über die digitale Immobilienverwaltung bis hin zur sensorgestützten Gebäudeüberwachung: enercity bietet der Immobilien- und Wohnungswirtschaft zahlreiche Lösungen, um ihre Quartiere attraktiv und zukunftssicher zu machen und die Kommunikation mit Mieterinnen und Mietern sowie Interessenten zu erleichtern. Von diesen intelligenten Systemen profitieren auch unsere Geschäftskundinnen und -kunden.'
            ],
            images: ['smart-01.jpg', 'smart-02.jpg']
          },
          {
            title: 'Dienstleistungen',
            headline: 'Energienah und effizient: <br>Unsere Services für Unternehmen',
            copy: [
              'Wir übernehmen die Direktvermarktung von überschüssigem Strom aus Photovoltaik-, Biomasse-, Windkraft-, Wasserkraft- oder KWK-Anlagen, optimieren die Energieeffizienz unserer Geschäftskundinnen und -kunden und vermitteln über unser Schulungscenter Wissen für Fachkräfte. So helfen wir dabei, Betriebskosten zu senken und neue Erlösquellen zu generieren.'
            ],
            images: ['service-01.jpg', 'service-02.jpg']
          }
        ]
      }
    },
    methods: {
      goTo(index) {
        const progress = 1 / this.slides.length * (index + 1) - 0.015;
        this.controller.scroll(this.controller.start + progress * (this.controller.end - this.controller.start));
      },
      calcTransform(index) {
        if (index === this.current) {
          return 'transform: translate3d(0, ' + this.currentOffset + 'px, 0)'
        }
        else if (index < this.current) {
          return 'transform: translate3d(0, 0, 0)';
        }
        else {
          return 'transform: translate3d(0, 60px, 0)';
        }
      },
      calcImage1Transform(index) {
        if (index === this.current) {
          return 'transform: translate3d(0, ' + (this.currentOffset * 2) + 'px, 0)'
        }
        else if (index < this.current) {
          return 'transform: translate3d(0, 0, 0)';
        }
        else {
          return 'transform: translate3d(0, 120px, 0)';
        }
      },
      getImageUrl(name) {
        return require('../assets/images/profile/' + name);
      },
      scrollerClick(e) {
        const t = this;
        const index = parseInt(e.currentTarget.dataset.index);
        const offset = this.$refs.mobileWrapper.children[index].offsetTop - (window.innerWidth > 700 ? 150 : 80);
        this.mobileCurrent = index;
        this.isScrolling = true;
        gsap.to('.content-wrapper',{
          scrollTo: {x: 0, y: offset},
          duration: 0.4,
          ease: Cubic.easeOut,
          onComplete() {
            t.isScrolling = false;
          }
        })
        //console.log(index);
      },
      initScroller(e) {
        const t = this;
        const image = e.currentTarget;
        const index = parseInt(image.dataset.index);

        gsap.to(image,{
          y: window.innerWidth / -3,
          scrollTrigger: {
            trigger: image,
            scrub: 0.1,
            scroller: '.content-wrapper',
            start: 'top 110%',
            end: 'bottom 0%',
            onUpdate(e) {
              t.mobileTexts[index] = 2 - e.progress * 4 > 1 ? 1 : 2 - e.progress * 4;//e.progress * 2 + 1 < 1 ? 2 - e.progress * 2 : 0;
              if (!t.isScrolling) {
                t.mobileCurrent = index;
              }
            }
          }
        })
      }
    },
    mounted() {
      const solutions = this.$refs.solutions;
      const t = this;

      for (let i = 0; i < t.slides.length; i++) {
        t.mobileTexts.push(1);
      }

      t.controller = ScrollTrigger.create({
        trigger: t.$refs.solutions,
        scrub: 0.2,
        scroller: '.content-wrapper',
        start: 'top 80%',
        end: 'bottom 100%',
        onUpdate (e) {
          t.current = Math.floor(e.progress * 7);
          if (t.current > t.slides.length - 1) {
            t.current = t.slides.length - 1;
          }
          t.currentProgress = e.progress * 7 - t.current;
          t.currentOffset = Math.round((1 - t.currentProgress) * 600) / 10;
        }
      });

      gsap.to(solutions,{
        opacity: 1,
        scrollTrigger: t.controller
      });
    }
  }
</script>

<style scoped>
  .mobile-solutions {
    display: block;
  }
  .items {
    margin-top: -20px;
    margin-bottom: 120px;
  }
  .item {
    position: relative;
    background-color: #fff;
    margin-bottom: calc(-10% + 10px);
  }
  .item:last-child {
    margin-bottom: -100px;
  }
  .text {
    position: sticky;
    top: 90px;
    padding: 10px 20px 20px;
  }
  .images {
    overflow: hidden;
    max-width: 100%;
  }
  .images img:first-child {
    max-width: 80%;
    margin-left: 20%;
  }
  .images img:last-child {
    margin-right: 20px;
    max-width: calc(100% - 20px);
    box-shadow: -200px 200px 0 200px white;
    transition: none;
  }
  .tabs {
    position: sticky;
    top: 64px;
    background-color: white;
    margin: 0 0 15px;
    overflow: auto;
    font-size: 0;
    z-index: 1;
  }
  .tabs ul {
    padding: 3px 10px;
    margin: 0;
    white-space: nowrap;
  }
  @media(min-width: 768px) {
    .text {
      max-width: 60%;
      padding: 40px 34px;
      top: 130px;
      font-size: 17px;
      font-weight: 400;
    }
    .tabs {
      top: 84px;
    }
    .tabs ul {
      padding: 5px 24px;
      display: flex;
      justify-content: space-between;
    }
    .images img:first-child {
      max-width: 60%;
      margin-left: 40%;
    }
    .images img:last-child {
      margin-right: 15%;
      max-width: 85%;
    }
  }
  @media(min-width: 1000px) {
    .items {
      margin-bottom: 0;
    }
    .item {
      margin-bottom: -70px;
    }
    .tabs {
      top: 77px;
    }
    .text {
      max-width: 50%;
      padding-top: 0;
      top: 150px;
      margin-top: 70px;
      margin-bottom: -150px;
    }
    .images img:first-child {
      max-width: 50%;
      margin-left: 50%;
    }
    .images img:last-child {
      margin-right: 30%;
      max-width: 70%;
      top: -5%;
    }
  }
  @media(min-width: 1200px) {
    .mobile-solutions {
      display: none;
    }
  }
  @media(max-width: 767px) {
    .tabs ul:after {
      content: ".";
      position: relative;
      display: block;
      min-width: 30px;
      color: white;
    }
  }
  .tabs li {
    display: inline-block;
  }
  .tabs button {
    position: relative;
    font-size: 18px;
    font-weight: 500;
    font-family: inherit;
    color: #102D61;
    border: 0;
    padding: 10px;
    background-color: transparent;
    opacity: 0.3;
    transition: 0.3s ease;
    cursor: pointer;
  }
  .tabs button:after {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    right: 50%;
    height: 2px;
    bottom: 8px;
    background-color: #102D61;
    opacity: 0;
    transition: 0.3s ease;
    border-radius: 2px;
  }
  .tabs button:focus {
    outline: 0;
    padding: 10px;
    display: inline-block;
  }
  .tabs .active button {
    opacity: 1;
  }
  .tabs .active button:after {
    opacity: 1;
    left: 10px;
    right: 10px;
  }
  @media(max-width: 767px) {
    .tabs button {
      font-size: 16px;
    }
    .items h3 {
      font-size: 17px;
    }
    .items {
      font-weight: 400;
      font-size: 14px;
    }
  }
  .solutions {
    width: 1200px;
    margin: 0 auto 60px;
    height: 600vh;
    max-width: 100%;
  }
  .outer {
    position: sticky;
    top: 140px;
    min-height: 850px;
  }
  h2 {
    position: relative;
    bottom: 100%;
    left: 0;
    right: 0;
    font-size: 65px;
    line-height: 0.95;
    font-weight: 700;
    text-align: left;
    margin: 0 -0.025em 10px;
    background: linear-gradient(90.02deg, #B1D995 1.4%, #3ABABA 90.79%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-left: 25%;
    padding-bottom: 10px;
  }
  .wrapper {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding-top: 10px;
  }
  .nav {
    flex: 1 1 25%;
    max-width: 25%;
    min-width: 25%;
  }
  .nav ul {
    list-style: none;
    text-align: right;
    padding: 0 30px 0 0;
    margin-left: -100px;
  }
  .nav button {
    background-color: transparent;
    border: 0;
    font-family: inherit;
    font-weight: 700;
    color: #102D61;
    opacity: 0.4;
    font-size: 32px;
    transition: 0.3s ease;
    cursor: pointer;
  }
  .nav button[data-from-active="2"] {
    opacity: 0.3;
  }
  .nav button[data-from-active="3"] {
    opacity: 0.2;
  }
  .nav button[data-from-active="4"] {
    opacity: 0.14;
  }
  .nav button[data-from-active="5"] {
    opacity: 0.09;
  }
  .nav button[data-from-active="6"] {
    opacity: 0.05;
  }
  .nav button:focus {
    outline: 0;
  }
  .nav button:hover, .nav .current button {
    opacity: 1;
  }
  .slides {
    position: relative;
    display: block;
    flex: 1 1 100%;
  }
  .slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    transition: opacity 0.4s ease, transform 0.2s ease;
  }
  .slide.prev .text-box {
    transform: translate3d(0, -50px, 0);
  }
  .slide.next .text-box {
    transform: translate3d(0, 50px, 0);
  }
  .slide.prev .image-box img {
    transform: translate3d(0, -250px, 0);
  }
  .slide.next .image-box img {
    transform: translate3d(0, 250px, 0);
  }
  .slide.prev .image-box + .image-box img {
    transform: translate3d(0, -100px, 0);
  }
  .slide.next .image-box + .image-box img {
    transform: translate3d(0, 100px, 0);
  }
  .slide.current {
    opacity: 1;
    transition: opacity 0.4s ease 0.3s;
    z-index: 1;
  }
  .slide.current .text-box, .slide.current img {
    transition: 0.4s ease 0.3s;
  }
  .text-box {
    width: 60%;
    transition: 0.4s ease;
    transform-origin: 0 0;
    transform: translate3d(0, 0, 0);
  }
  .text-box + .image-box {
    position: relative;
    display: block;
    width: 90%;
    left: 15%;
    z-index: 1;
    margin-top: 4%;
  }
  .image-box:last-child {
    position: absolute;
    left: 70%;
    top: 100px;
    width: calc(50vw - 340px);
  }
  @media(max-height: 799px) {
    .image-box:last-child {
      width: calc(50vw - 270px);
    }
  }
  img {
    position: relative;
    display: block;
    width: 100%;
    height: auto;
    transition: 0.4s ease;
  }
  h3 {
    font-size: 22px;
    font-weight: 500;
    line-height: 1.4;
    padding-right: 10%;
    margin-top: 15px;
  }

  @media(max-height: 799px) {
    .solutions {
      width: 1000px;
    }
    .nav {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      flex: 1 1 200px;
    }
    h2 {
      max-width: 720px;
      padding-left: 200px;
    }
    button {
      font-size: 24px;
    }
    .outer {
      top: -55px;
    }
  }

  @media(max-width: 1199px) {
    .solutions.desktop {
      display: none;
    }
    h2 {
      max-width: 600px;
      margin-left: 34px;
      margin-bottom: 40px;
      padding-left: 0;
    }
  }
  @media(max-width: 767px) {
    h2 {
      font-size: 32px;
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 5px;
    }
  }
</style>